/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface PinnedCheckDto { 
    pinId?: string;
    definitionId?: string;
    name?: string;
    projectId?: number;
    scope?: PinnedCheckDto.ScopeEnum;
    status?: PinnedCheckDto.StatusEnum;
}
export namespace PinnedCheckDto {
    export type ScopeEnum = 'USER' | 'PROJECT' | 'ORGANISATION';
    export const ScopeEnum = {
        USER: 'USER' as ScopeEnum,
        PROJECT: 'PROJECT' as ScopeEnum,
        ORGANISATION: 'ORGANISATION' as ScopeEnum
    };
    export type StatusEnum = 'DRAFT' | 'ACTIVE' | 'INACTIVE' | 'ARCHIVED';
    export const StatusEnum = {
        DRAFT: 'DRAFT' as StatusEnum,
        ACTIVE: 'ACTIVE' as StatusEnum,
        INACTIVE: 'INACTIVE' as StatusEnum,
        ARCHIVED: 'ARCHIVED' as StatusEnum
    };
}